// import state from '@/store/modules/authUser/state.js'
import actions from '@/store/modules/authUser/actions.js'
import mutations from '@/store/modules/authUser/mutations.js'
import getters from '@/store/modules/authUser/getters.js'

// initial state

export const getDefaultState = () => {
    return {
        jobsBasket: new Set(),
        noJobsBasket: new Set(),
        userIsLoggedIn: false,
        smartAgent: {
            currentStep: 1,
            firstStepCategory: {
                cat: '',
                email: ''
            }
        }
    }
}

const state = () => getDefaultState()

const userAuthModule = {
    state,
    getters,
    actions,
    mutations,
    getDefaultState
}

export default userAuthModule